<template>

    <trax-ui-vertical-timeline :data="historyData">
    </trax-ui-vertical-timeline>
    
</template>

<script>
    export default {
    
        data: function() {
            return {
                lang: lang,
                locations_names_uuid: data.locations_names_uuid,
                state: data.state,
            }
        },

        computed: {
        
            historyData: function() {
                var data = [];
                if (this.state == undefined || !this.state.attempts) return [];
                for (var index in this.state.attempts) {
                    var attempt = this.state.attempts[index];
                    if (attempt.success == undefined) continue;

                    var attemptData = {};

                    // Icon
                    attemptData.icon = 'flight_takeoff';
                    if (attempt.success == 3) attemptData.color = 'success';
                    else if (attempt.success == 2) attemptData.color = 'warning';
                    else if (attempt.success == 1) attemptData.color = 'danger';
                    
                    // Heading
                    attemptData.heading = '';
                    if (attempt.date) {
                        var date = attempt.date;
                        if (moment(date, 'YYYY-MM-DD', true).isValid()) date = moment(date).format('DD MMM YYYY');
                        attemptData.heading += '<span class="badge badge-'+attemptData.color+'">'+date+'</span> ';
                    }
                    
                    // Footer
                    attemptData.footer = '<h6>';
                    if (attempt.location) {
                        attemptData.footer += '<span class="mr-3">';
                        attemptData.footer += '<i class="material-icons">location_on</i>';
                        var name = this.locations_names_uuid[attempt.location.entity_uuid];
                        if (!name) name = attempt.location.entity_name;
                        attemptData.footer += name;
                        attemptData.footer += '</span>';
                    }
                    if (attempt.duration) {
                        attemptData.footer += '<span>';
                        attemptData.footer += '<i class="material-icons">access_time</i>';
                        attemptData.footer += attempt.duration+'H';
                        attemptData.footer += '</span>';
                    }
                    attemptData.footer += '</h6>';
                    data.push(attemptData);
                }
                return data;
            }
        }

    }
</script>
